module.exports = __webpack_public_path__ + "img/ciie.905df7f9.png";